// extracted by mini-css-extract-plugin
module.exports = {"root":"CardPage_root__233iR"};